<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Z6TqLA/tc-custom/scover.jpg?1685327060757?1713839839123" alt="This image is the cover for the book Haunted"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted
      </h1>
      <p class="bookDescription body article font2">
        <p>Steven and Conrad have a weird relationship, one Steven can't figure out no matter how many times he looks at it. After weeks of hot sex and sweaty grappling Steven finds himself taking a romantic stroll on the beach with a woman, and the confusion he feels about his life overwhelms him.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vincent Diamond
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ba1ecb82